import { Badge } from "@/components/ui/badge"; // Adjust import path as needed

interface PaymentStatusBadgeProps {
  status: "paid" | "pending" | string;
}

export function PaymentStatusBadge({ status }: PaymentStatusBadgeProps) {
  return status === "confirmed" ? (
    <Badge className="bg-blue-100 text-blue-700 hover:bg-blue-100">
      Confirmed
    </Badge>
  ) : (
    <Badge
      variant="outline"
      className="bg-yellow-50 text-yellow-700 border-yellow-300"
    >
      Payment Pending
    </Badge>
  );
}